module.exports = __webpack_public_path__ + "static/media/back.47c813d7.svg";